/** @jsx jsx */
import { jsx, Flex, Box } from 'theme-ui';
/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { CTA } from '../../@types/cta';
import { AwardImage } from '../../@types/award';

// Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import CTAButton from '../../components/ctaButton';
import Text, { TEXT_TYPES } from '../../components/text';

// Styles
import * as style from './style';

interface AwardsListProps extends Section {
  cta: CTA;
  title: {
    title?: string;
  };
  awardsList: {
    awardsList: Array<AwardImage>;
  };
  text: {
    text?: string;
  };
}

const AwardsList: SectionComponent<AwardsListProps> = React.memo(
  ({ awardsList, cta, text, title }) => (
    <Flex sx={style.AwardsListContainer}>
      {!!title.title && (
        <Text type={TEXT_TYPES.H1_BOLD}>
          <span dangerouslySetInnerHTML={{ __html: title.title }} />
        </Text>
      )}
      {!!text.text && (
        <Text type={TEXT_TYPES.H5} sx={style.AwardsText}>
          <span dangerouslySetInnerHTML={{ __html: text.text }} />
        </Text>
      )}
      <Flex sx={style.AwardImagesContainer}>
        {(awardsList?.awardsList?.length ?? 0) > 0 &&
          awardsList.awardsList.map((award: AwardImage, idx: number) => (
            <Box key={idx} sx={style.AwardBox}>
              <FluidImage {...award.awardImage} sx={style.AwardImage} />
            </Box>
          ))}
      </Flex>

      <CTAButton cta={cta} type="link" sx={style.CtaButton}>
        {cta.label}
      </CTAButton>
    </Flex>
  ),
);

export default AwardsList;
